import * as createListSlice from './createListSlice';

const slices = {
  ...createListSlice,
};
export default slices;
